import React from "react";
import "./StaticInfoPage.css";

const VISOR_URL = "http://historiavolcanes.sgc.gov.co/visor/";

function AcercaPage() {
  return (
    <div className="static-page">
      <div className="static-page__inner">
        <h1 className="static-page__title">Acerca de</h1>

        <div className="static-card">
          <div className="static-card__accent" aria-hidden />
          <h2 className="acerca-section-title">¿Cómo citar esta página?</h2>

          <blockquote className="citation-block">
            <p>
              Servicio Geológico Colombiano. Sistema de Información de Actividad
              volcánica Histórica de Colombia [En línea].
            </p>
            <p>Disponible en:</p>
            <p className="citation-url">
              <a href={VISOR_URL} target="_blank" rel="noopener noreferrer">
                {VISOR_URL}
              </a>
            </p>
            <p>[Fecha de consulta: DD/MM/AAAA].</p>
          </blockquote>

          <p className="static-page__note">
            La información puede complementarse cuando se trata de un volcán o
            actividad puntual.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AcercaPage;
